import { render, staticRenderFns } from "./vinRequestStat.vue?vue&type=template&id=5af4de1a&scoped=true&"
import script from "./vinRequestStat.vue?vue&type=script&lang=js&"
export * from "./vinRequestStat.vue?vue&type=script&lang=js&"
import style0 from "./vinRequestStat.vue?vue&type=style&index=0&id=5af4de1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af4de1a",
  null
  
)

component.options.__file = "vinRequestStat.vue"
export default component.exports